import * as yup from 'yup';

export const CreateProjectTypeFormValidation = yup.object().shape({
  description: yup.string().required('Descrição é obrigatória'),
});
